export type SelectableOptionCardIconSet = 'material-symbols-rounded' | 'material-icons' | 'material-icons-outlined';

export const DEFAULT_SELECTABLE_OPTION_CARD_ICON = 'checklist';
export const DEFAULT_SELECTABLE_OPTION_CARD_ICON_SET: SelectableOptionCardIconSet = 'material-symbols-rounded';
export const DEFAULT_SELECTABLE_OPTION_CARD_SELECTED = false;
export const DEFAULT_SELECTABLE_OPTION_CARD_DISABLED = false;
